import { useQueryState, parseAsStringEnum } from 'nuqs';
import type { CustomerDetailData } from '~/types/customer-detail.types';
import { CustomerDetailHeader } from './customer-detail-header';
import { CustomerDetailTabs, type CustomerDetailTabValue } from './customer-detail-tabs';
import { BaseCardsTabContent } from './base-cards-tab-content';
import { BranchTabContent } from './branch-tab-content';
import { AnnouncementsTabContent } from './announcements-tab-content';
import { ReserveTabContent } from './reserve-tab-content';

interface CustomerDetailBaseProps {
  data: CustomerDetailData;
}

const tabValues: CustomerDetailTabValue[] = ['base_cards', 'branch', 'announcements', 'reserve'];

/**
 * 顧客詳細ページの統合ベースコンポーネント
 *
 * 全ての顧客タイプ（customer/branch/store/non/others）で共通利用可能
 */
export const CustomerDetailBase = ({ data }: CustomerDetailBaseProps) => {
  const [activeTab, setActiveTab] = useQueryState(
    'tab',
    parseAsStringEnum(tabValues).withDefault('base_cards')
  );

  return (
    <main>
      {/* ヘッダー: 顧客基本情報と営業ステータス */}
      <CustomerDetailHeader data={data} />

      {/* タブ: 基本情報、枝客、営業履歴、予約履歴 */}
      <CustomerDetailTabs
        data={data}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        baseCardsContent={<BaseCardsTabContent data={data} />}
        branchContent={<BranchTabContent data={data} />}
        announcementsContent={<AnnouncementsTabContent data={data} />}
        reserveContent={<ReserveTabContent data={data} />}
      />
    </main>
  );
};
